var exports = {
  "kZ": "xaee3c4fa--6e85c0--image-wrapper",
  "o5": "xaee3c4fa--6e85c0--content-wrapper",
  "q9": "xaee3c4fa--6e85c0--price",
  "DD": "xaee3c4fa--6e85c0--title",
  "gZ": "xaee3c4fa--6e85c0--underground-wrapper",
  "hl": "xaee3c4fa--6e85c0--address",
  "Pg": "xaee3c4fa--6e85c0--_two-strings",
};

module.exports = exports;
